<template>
  <el-dialog title="Adicionar Lançamento Futuro" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="400px">
    <el-form :model="lancamentoFuturo" :rules="validacao" ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="locatario" label="Cliente">
            <el-select v-model="lancamentoFuturo.locatario" value-key="id" style="width:100%;">
              <el-option
                v-for="item in clientesContrato"
                :key="item.id"
                :label="item.nome"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="mesSerie" label="Mês Série">
            <el-input v-model="lancamentoFuturo.mesSerie" style="width:100%;" v-mask="'###'" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="tipo" label="Tipo">
            <el-select v-model="lancamentoFuturo.tipo" style="width:100%;">
              <el-option v-for="item in tipoLancamento" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

       <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Descrição" >
            <el-select v-model="descricaoFixa" style="width:100%;" value-key="label" placeholder="">
              <el-option v-for="item in DESCRICAO_ITENS" :key="item.label" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Descrição (Opcional)">
            <el-input v-model="descricaoLivre"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item prop="valor" label="Valor">
            <money
              v-model="lancamentoFuturo.valor"
              v-bind="money"
              class="el-input__inner"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Repetir por mais">
            <el-input v-model="lancamentoFuturo.quantidadeMeses" v-mask="'##'">
              <template slot="append">meses</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="gravarHandler" type="primary" size="small" round class="btn-box-shadow">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Util from "../../../util/funcoes.js";
import {TIPO_ITEM_RECIBO} from "../../../util/constantes.js"
import { Money } from "v-money";

export default {
  components:{
    Money
  },
  props: {
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      descricaoFixa: '',
      descricaoLivre: '',
      lancamentoFuturo: {},

      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "R$ ",
        masked: false
      },

      validacao: {
        locatario: [{ required: true, }],
        mesSerie: [{ required: true }],
        tipo: [{ required: true }],
        valor: [{ required: true, validator: this.validadorValor }],
        nome: [{ required: true }]
      },
      DESCRICAO_ITENS: [
				{label: "", data: ""},
				{label: "Água", data: "Água"},
				{label: "Cartório", data: "Cartório"},
				{label: "Condomínio", data: "Condomínio"},
				{label: "Condomínio Tx. Extra", data: "Condomínio Tx. Extra"},
				{label: "Correios", data: "Correios"},
				{label: "Energia Elétrica", data: "Energia Elétrica"},
				{label: "Gás", data: "Gás"},
				{label: "IPTU", data: "IPTU"},
				{label: "IPTU/Taxa de Lixo", data: "IPTU/Taxa de Lixo"},
				{label: "IRRF", data: "IRRF"},
				{label: "Reforma", data: "REFORMA"},
				{label: "Seguro", data: "Seguro"},
				{label: "Tarifas Bancárias", data: "Tarifas Bancárias"},
				{label: "Taxa de Lixo", data: "Taxa de Lixo"},
				{label: "Taxa de Serviço", data: "Taxa de Serviço"},
				{label: "Telefone", data: "Telefone"},
				{label: "Outros", data: "Outros"}
      ],
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),
    descricaoItem() {
      return this.descricaoFixa.concat(this.descricaoLivre ? ' - ' + this.descricaoLivre : '')
    },
    clientesContrato() {
      return this.$store.state.alugueisContratosStore.clientesContrato;
    },
    util() {
      return Util;
    },
    tipoLancamento() {
      return TIPO_ITEM_RECIBO;
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisContratosStore", ["gravarLancamentoFuturo","recuperarEnvolvidos"]),

    iniciar() {
      this.showLoading();
      let payload = { aluguel: { id: this.aluguel.id } }
      this.recuperarEnvolvidos(payload)
      .then(() => {
      }).finally(() => {
        this.hideLoading();
      })
    },
    validadorValor(rule, value, callback) {
      if(value > 0) {
        return callback();
      } else {
        return callback(new Error());
      }
    },
        
    descricao(){
      if(this.descricaoFixa === 'IRRF') {
        this.lancamentoFuturo.categoria = 'IRRF'
      } else if(this.descricaoFixa === 'IPTU' || this.descricaoFixa === 'IPTU/Taxa de Lixo') {
        this.lancamentoFuturo.categoria = 'IPTU'
      } else if(this.descricaoFixa === 'REFORMA') {
        this.lancamentoFuturo.categoria = 'REFORMA'
      } else {
        this.lancamentoFuturo.categoria = 'OUTROS'
      }
    },

    gravarHandler() {
      this.descricao(), 
      this.lancamentoFuturo.aluguel = { id: this.aluguel.id }
      this.lancamentoFuturo.nome = this.descricaoItem
      this.$refs['form'].validate(elFormIsValidate => {
       const formIsInvalid = !elFormIsValidate;
       if(formIsInvalid) {
         this.exibirAlerta("Preencha todos os campos obrigatórios");
         return
       }
        this.gravar();
     })
    },
    gravar() {
      this.showLoading();
      this.gravarLancamentoFuturo(this.lancamentoFuturo)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          default:
            this.$message.error(resultado.mensagem);
            break;
        }
        this.fechar();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    exibirAlerta(mensagem) {
      this.$alert(mensagem, 'Atenção', { confirmButtonText: 'OK', type: 'error' });
    },

    reset() {
      this.descricaoFixa = ''
      this.descricaoLivre = ''
      this.lancamentoFuturo = {}
    },
    fechar() {
      this.reset();
      this.$emit('close');
    }, 
  }
}
</script>
